export const fakerOptions = `Here are some of the fakerOptions available for some of the faker types:
helpers.enumValue: { <key>: <value>, ... }
helpers.arrayElements: { array: [<value>, ...], { count: <number> | { min: <number>, max: <number> } }
helpers.fromRegExp: '<regex>'
airline.flightNumber: { addLeadingZeros: <boolean>, length: <number> | { min: <number>, max: <number> } }
airline.recordLocator: { allowNumeric: <boolean>, allowVisuallySimilarCharacters: <boolean> }
airline.seat: { aircraftType: 'narrowbody' | 'regional' | 'widebody' }
commerce.isbn: { separator?: <string>, variant: 10 | 13 } 
commerce.price: { dec?: <number>, max?: <number>, min?: <number> }
datatype.boolean: { probability?: <number> }
date.anytime: { refDate?: <string> | <number> | <Date> }
date.between: { from: <string> | <number> | <Date>, to: <string> | <number> | <Date> }
date.betweens: { from: <string> | <number> | <Date>, to: <string> | <number> | <Date>, count: <number> | { min: <number>, max: <number> } }
date.birthdate: { refDate?: <string> | <number> | <Date>, min: <number>, max: <number>, mode: 'age' | 'year' }
date.future, date.past: { refDate?: <string> | <number> | <Date>, years?: <number> }
date.month, date.weekday: { abbreviated?: <boolean>, context?: <boolean> }
date.recent, date.soon: { refDate?: <string> | <number> | <Date>, days?: <number> }
finance.accountNumber: { optionsOrLength?: <number> | { length: <number> } }
finance.amount: { autoFormat?: <boolean>, dec?: <number>, max?: <number>, min?: <number> }
finance.bic: { includeBranchCode?: <boolean> }
finance.bitcoinAddress: { network?: 'mainnet' | 'testnet', type?: 'legacy' | 'segwit' | 'bech32' | 'taproot' }
finance.creditCardNumber: { issuer?: <string> }
finance.iban: { formatted?: <boolean>, countryCode?: <string> }
finance.maskedNumber: { ellipsis?: <boolean>, length?: <number>, parens?: <boolean> }
finance.pin: { length?: <number> }
number.int: { max: 100000, min: 1 }
number.float: { max: 100000, min: 1 }
phone.number: { style?: 'international' | 'national' | 'human' }
string.alpha, string.alphaNumeric: { casing?: 'lower' | 'upper' | 'mixed', length?: <number>, exclude?: <string> | <AlphaChar | string>[] }
string.binary: { length?: <number>, prefix?: <string> }
string.fromCharacters: { characters: <string> | <string>[], length: <number> | { min: <number>, max: <number> } }
string.hexadecimal: { length?: <number>, prefix?: <string>, casing?: 'lower' | 'upper' | 'mixed' }

`;
